import { createAction, props } from '@ngrx/store';
import { EntitiesEnum } from '@match-fix/shared';
import { TcListFilterModel, TcListSortModel } from '@tc/core';

export const navigateToRoute = createAction(
    '[Main] Navigate To Route',
    props<{ route: string}>());
  